import type { UseMutationResult } from '@tanstack/react-query'
import { useMutation } from '@tanstack/react-query'
import fileDownload from 'js-file-download'
import type { DateTime } from 'luxon'

import { exportProductionPlan } from '@/features/wholesale/endpoints/productionPlan'

export type UseProductionPlanExportResult = Omit<UseMutationResult<void, Error, DateTime>, 'mutateAsync'> & {
  exportProductionPlan: UseMutationResult<void, Error, DateTime>['mutateAsync']
}

export function useProductionPlanExport(): UseProductionPlanExportResult {
  const { mutateAsync, ...mutationResult } = useMutation({
    mutationFn: async (date: DateTime) => {
      const { blob, filename } = await exportProductionPlan(date)
      const fallback = `export_production_plan_${date.toFormat('yyyy-LL-dd')}.csv`
      fileDownload(blob, filename ?? fallback)
    },
  })

  return {
    exportProductionPlan: mutateAsync,
    ...mutationResult,
  }
}
